<template>
  <div class="footer">
    <el-row class="flex-box">
      <el-col :sm="24" :md="10">
        <div class="related-links">
          <h3>相关链接</h3>

          <router-link class="link" :to="'/contact'">联系我们</router-link>
          <a class="link" href="https://songxichen.com/index.php/User"
            >团队成员</a
          >
          <a
            class="link"
            href="https://songxichen.com/index.php/Index/Article/index/id/10"
            >其他工作</a
          >
          <a class="link" href="https://www.stat-center.pku.edu.cn/index.htm"
            >北京大学统计科学中心</a
          >
          <div class="funding">
            <h4>项目资助</h4>
            <div>国家重点研发计划专项项目2016YFC0207700</div>
            <div>国家自然科学基金重点项目71532001</div>
          </div>
        </div>
      </el-col>
      <el-col :sm="24" :md="6" class="address">
        <ul>
          <li>地 址: 北京市海淀区北京大学理科5号楼</li>
          <li>邮 编: 100871</li>
          <li>联系电话：+86 10-6276-0736</li>
          <li>邮 箱：pm_group@163.com</li>
          <li>访问人次：{{ this.ipNumber + 2023 }}</li>
        </ul>
      </el-col>

      <el-col :sm="24" :md="8" class="logo">
        <h1>空气质量评估平台</h1>
        <div class="logo-img">
          <el-image class="title-img" :src="imgsrc" fit="contain"></el-image>
        </div>
      </el-col>
    </el-row>

    <div class="copyright">
      <!-- Copyright &copy; Since 2017 Song Xi Chen Research Group -->
      Copyright &copy; 陈松蹊研究团队
      <el-backtop target></el-backtop>
    </div>
  </div>
</template>

<script>
export default {
  name: "HFooter",
  data() {
    return {
      imgsrc: require("@/assets/pkulogo_grey.png"),
      ipNumber: parseInt(this.$IPRecorded),
    };
  },
  watch: {},
  create() {
    // 获取 IP 访问数量等信息
  },
  methods: {
    getIPN() {
      return this.$IPRecorded;
    },
  },
  mounted() {},
};
</script>

<style  scoped>
.footer {
  background-color: rgba(150, 11, 11, 0.9);
}
.flex-box {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-content: center;
  align-items: stretch;
  max-width: 1280px;
  color: #d6d6d6;
  margin: 0 auto;
}

/* 相关链接 */
.related-links {
  padding-top: 20px;
  padding-left: 10px;
}
.related-links h3,
h4 {
  text-align: left;
}
.link {
  text-decoration: none;
  color: #d6d6d6;
  border-bottom: 1px solid transparent;
  margin-right: 15px;
  padding: 5px 0;
}

.link:hover {
  border-bottom: 2px solid rgba(255, 145, 0, 0.5);
}
.el-link {
  margin-bottom: 5px;
  /* color: #eee8e8 !important; */
}
/* funding */
.funding h4 {
  margin-bottom: 5px;
}
.funding div {
  font-size: 10px;
}
/* 地址部分 */

.address ul {
  display: inline-block;
  align-self: center;
  padding: 40px 10px;
  margin: 0 auto;
}
.address ul li {
  list-style: none;
  line-height: 30px;
  font-size: 14px;
}

/* logo */
.logo {
  padding: 30px 10px;
}
.logo .logo-img {
  text-align: center;
}
/* .footer-contact {
  background-color: rgb(150, 11, 11);
  color: #fff;
  padding: 20px 0;
}
.flex-box {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-content: center;
  align-items: stretch;
  max-width: 1200px;
  margin: 0 auto;
} */

.copyright {
  padding: 10px;
  background-color: #770101;
  color: #dccbcb;
  text-align: center;
  font-size: 10px;
}

.title-img {
  width: 120px;
  margin-right: 15px;
}
</style>>
